// src/components/dashboard/InviteWidget/InviteWidget.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './InviteWidget.css';

const InviteWidget = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to portfolio page with invite tab active
    navigate('/portfolio', { state: { activeTab: 'invite' } });
  };

  return (
    <div className="invite-widget-container">
      <button 
        className="invite-icon-button" 
        onClick={handleClick}
        title="Invite friends and earn rewards"
      >
        {/* People/Users Icon Symbol */}
        <div className="invite-symbol">
          <div className="person person-1"></div>
          <div className="person person-2"></div>
        </div>
      </button>
      
      <span className="widget-label">Invite Friends</span>
    </div>
  );
};

export default InviteWidget;